import {config} from '../config';
import { handleResponse, buildQuery } from '../helpers';

export const bicycleParkingService = {
    getBicycleParking,
    getAll

}


function getBicycleParking(parkingId) {
    const requestOptions = { 
        method: 'GET' 
    };
    return fetch(`${config.apiUrl}/bicycleparking/?id=${parkingId}`, requestOptions).then(handleResponse);
}

function getAll() {
    const requestOptions = { 
        method: 'GET' 
    };
    return fetch(`${config.apiUrl}/bicycleparking/`, requestOptions).then(handleResponse);
}